var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationMarkCircleGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9 17C13.1421 17 16.5 13.6421 16.5 9.5C16.5 5.35786 13.1421 2 9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.8125C9.3075 10.8125 9.5625 10.5575 9.5625 10.25V6.5C9.5625 6.1925 9.3075 5.9375 9 5.9375C8.6925 5.9375 8.4375 6.1925 8.4375 6.5V10.25C8.4375 10.5575 8.6925 10.8125 9 10.8125Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69 12.215C9.6525 12.125 9.6 12.0425 9.5325 11.9675C9.4575 11.9 9.375 11.8475 9.285 11.81C9.105 11.735 8.895 11.735 8.715 11.81C8.625 11.8475 8.5425 11.9 8.4675 11.9675C8.4 12.0425 8.3475 12.125 8.31 12.215C8.2725 12.305 8.25 12.4025 8.25 12.5C8.25 12.5975 8.2725 12.695 8.31 12.785C8.3475 12.8825 8.4 12.9575 8.4675 13.0325C8.5425 13.1 8.625 13.1525 8.715 13.19C8.805 13.2275 8.9025 13.25 9 13.25C9.0975 13.25 9.195 13.2275 9.285 13.19C9.375 13.1525 9.4575 13.1 9.5325 13.0325C9.6 12.9575 9.6525 12.8825 9.69 12.785C9.7275 12.695 9.75 12.5975 9.75 12.5C9.75 12.4025 9.7275 12.305 9.69 12.215Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkCircleGrey);
export default __webpack_public_path__ + "static/media/exclamation-mark-circle--grey.d3d3bd96808387c5508b78ee37fc0886.svg";
export { ForwardRef as ReactComponent };